<bepatient-question-title-v3
  [title]="question.label"
  [constraints]="question.constraints"
  [color]="color"
  [errors]="question.errors"
  [css]="question.css"
  [formGroup]="formGroup"
>
</bepatient-question-title-v3>

<ng-container [formGroup]="formGroup">
  <ion-item
    *ngFor="let nestedQuestion of question.nestedQuestions; let i = index"
    [formArrayName]="question.key"
    [ngSwitch]="nestedQuestion.controlType"
  >
    <ion-checkbox
      *ngSwitchCase="'checkbox'"
      [formControlName]="i"
      [id]="i"
      [color]="nestedQuestion.color"
      [attr.disabled]="question.disabled || question.readonly"
      labelPlacement="question.controlType === 'textbox' || question.controlType === 'dropdown'? 'floating' : 'fixed'"
    >
      {{ nestedQuestion.label | translate }}
    </ion-checkbox>

    <ion-datetime
      *ngSwitchCase="'datetime'"
      [formControlName]="i"
      mode="ios"
      [id]="i"
      [attr.disabled]="question.disabled"
      [attr.readonly]="question.readonly"
      [max]="nestedQuestion.max"
      [min]="nestedQuestion.min"
      [cancelText]="nestedQuestion.cancelText | translate"
      [doneText]="nestedQuestion.doneText | translate"
    >
    </ion-datetime>

    <ion-item *ngSwitchCase="'textbox'">
      <ion-input
        [type]="nestedQuestion.type"
        [attr.disabled]="question.disabled"
        [attr.readonly]="question.readonly"
        [formControlName]="i"
      >
      </ion-input>
    </ion-item>

    <ion-select
      *ngSwitchCase="'dropdown'"
      [formControlName]="i"
      [id]="i"
      [attr.disabled]="question.disabled || question.readonly"
      [value]="nestedQuestion.options[nestedQuestion.defaultValue].key"
      [okText]="nestedQuestion.okText"
      [cancelText]="nestedQuestion.cancelText"
    >
      <ion-select-option
        *ngFor="let opt of nestedQuestion.options"
        [value]="opt.key"
      >
        {{ opt.value }}
      </ion-select-option>
    </ion-select>

    <ion-radio-group
      *ngSwitchCase="'radio'"
      [formControlName]="i"
      [id]="i"
      [attr.disabled]="question.disabled || question.readonly"
    >
      <ion-list-header> {{ nestedQuestion.label }} </ion-list-header>
      <ion-item *ngFor="let opt of nestedQuestion.options">
        <ion-radio [value]="opt.value" [attr.aria-label]="opt.key">{{
          opt.key
        }}</ion-radio>
      </ion-item>
    </ion-radio-group>

    <ion-range
      *ngSwitchCase="'range'"
      [formControlName]="i"
      [id]="i"
      [min]="nestedQuestion.min"
      [max]="nestedQuestion.max"
      [step]="nestedQuestion.step"
      [color]="nestedQuestion.color"
      [name]="nestedQuestion.key"
      [value]="nestedQuestion.value"
      [dualKnobs]="nestedQuestion.dualKnobs"
      [attr.disabled]="question.disabled || question.readonly"
      [attr.disabled]="question.disabled || question.readonly"
    >
      <ion-icon
        size="small"
        [name]="nestedQuestion.startIcon"
        slot="start"
      ></ion-icon>
      <ion-icon
        size="small"
        [name]="nestedQuestion.endIcon"
        slot="end"
      ></ion-icon>

      <ion-label *ngIf="!nestedQuestion.startIcon" slot="start">
        {{ nestedQuestion.startLabel }}
      </ion-label>
      <ion-label *ngIf="!nestedQuestion.startIcon" slot="end">
        {{ nestedQuestion.endLabel }}
      </ion-label>
    </ion-range>

    <ion-toggle
      *ngSwitchCase="'toggle'"
      [formControlName]="i"
      [id]="i"
      [checked]="nestedQuestion.value"
      [attr.disabled]="question.disabled || question.readonly"
    >
    </ion-toggle>
  </ion-item>
</ng-container>
